import React, {Component} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Table} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AddButton from "../../../../common/AddButton/AddButton";
import Checkbox from "../../../../common/Checkbox/Checkbox";
import Loading from "../../../../common/Loading/Loading";
import ConfirmDialog from "../../../../common/ConfirmDialog/ConfirmDialog";
import ProductService from "../../../../services/product-service";
import toastr from "toastr";
import ToastOptions from "../../../../common/toast/toastr-config.js";
import "./Services.css";
import Permissions from "../../../../authentication/Permissions";
import AuthorizationService from "../../../../services/authorization-service";

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      newSelectedServices: [],
      isAddServiceModalVisible: false,
      invalidFields: {
        newSelectedServices: {
          invalid: false,
          message: ""
        }
      }, 
      isDeleteServiceModalVisible: false,
      deleteServiceId: "",
      isDialogLoading: false
    }
  }

  fetchProductServices = async () => {
    try {
      this.setState({isDialogLoading: true});
      const added = this.props.services
          ? this.props.services.map(s => s.serviceName)
          : [];
      let product = await ProductService.getProductById(this.props.sub.connectedProducts[0].productId);
      const filtered = product.data.services.filter(s => !added.includes(s.serviceName));
      this.setState({
        services: filtered,
        isDialogLoading: false,
        newSelectedServices: filtered,
      });
    } catch (error) {
      this.setState({isDialogLoading: false});
      console.log(error);
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  }

  handleAddServiceDialogToggle = async () => {
    if (!this.state.isAddServiceModalVisible) {
      this.setState({
        isDialogLoading: true,
        isAddServiceModalVisible: true
      });
      await this.fetchProductServices();
      this.setState({
        isDialogLoading: false
      });
    } 
  };

  resetState = () => {
    this.setState({
      services: [],
      newSelectedServices: [],
      isAddServiceModalVisible: false,
      isDialogLoading: false,
      invalidFields: {
        newSelectedServices: {
          invalid: false,
          message: ""
        }
      }, 
    })
  }

  editSubscriptionServices = async () => {
    if(this.state.services.length > 0 && this.state.newSelectedServices.length > 0) {
      try {
        let updateSub = {...this.props.sub}
        updateSub.connectedProducts[0].services = [...this.state.newSelectedServices];
        this.props.updateSubscription(updateSub)
        this.setState({isAddServiceModalVisible: false});
      } catch(error) {
        this.setState({ isDialogLoading: false });
        toastr.options = ToastOptions;
        toastr.error(error.message);
      }
    } else if (this.state.newSelectedServices.length === 0 && this.state.services.length > 0) {
      this.setState({
        invalidFields: {
          newSelectedServices: {
            invalid: true,
            message: "Select service if you want to proceed."
          }
        }
      })
    }
  }

  deleteService = async () => {
    try {
      this.setState({isDialogLoading: true});
      const updateSub = {...this.props.sub};
      updateSub.connectedProducts[0].services = updateSub.connectedProducts[0].services.filter(s => s.serviceName !== this.state.deleteServiceId);
      await this.props.updateSubscription(updateSub);
      this.setState({
        isDeleteServiceModalVisible: false,
        deleteServiceId: "",
        isDialogLoading: false,
        newSelectedServices: []
      });
    } catch(error) {
      this.setState({ isDialogLoading: false });
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  }

  handleSelectService = (service) => {
    let filteredServices = this.state.newSelectedServices.filter(s => s.serviceName === service.serviceName);

    if(filteredServices.length === 0){
      const services = this.state.newSelectedServices;
      services.push(service);
      this.setState({ newSelectedServices: services });
    } else {
      const services = this.state.newSelectedServices.filter(s => s.serviceName !== service.serviceName);
      this.setState({ newSelectedServices: services });
    }

    if(this.state.newSelectedServices.length > 0){
      this.setState({
        invalidFields: {
          newSelectedServices: {
            invalid: false,
            message: ""
          }
        }
      })
    }
  }

  populateTable = () => {
    let services = this.props.sub.connectedProducts[0].services;
    return services.map((s, i) => {
      return (
          <tr key={i}>
            <td className="width-90">{s.serviceName}</td>
            <td className="width-10">
              {(AuthorizationService.hasPermission(Permissions.subscription.delete) && services.length > 1 && this.props.sub.isActive && !this.props.sub.isSynchronize) &&
              <FontAwesomeIcon
                  className="fas delete-icon"
                  icon="times"
                  size="sm"
                  color="#59595B"
                  onClick={() => {
                    this.setState({isDeleteServiceModalVisible: true, deleteServiceId: s.serviceName})
                  }}
              />
              }
          </td>
        </tr>
      );
    });
  };

  renderServices = () => {
    return this.state.services.map(s => {
      return <Checkbox
          key={s.serviceName}
          id={s.serviceName}
          label={s.displayName}
          isChecked={this.state.newSelectedServices.filter(item => item.serviceName === s.serviceName).length > 0}
          handleChange={() => this.handleSelectService(s)}
      />
    })
  }

  render() {
    return (
      <div className="account-services">
        {AuthorizationService.hasPermission(Permissions.subscription.add) && this.props.sub.isActive && !this.props.sub.isSynchronize &&
        <AddButton
            name="Add service"
            handleCreateDialogToggle={this.handleAddServiceDialogToggle}
            className="btn-add-key"
        />
        }

        {/* Delete service */}
        <ConfirmDialog
          toggleState={this.state.isDeleteServiceModalVisible}
          cancelAction={() =>
            this.setState({ isDeleteServiceModalVisible: false })
          }
          message={"Are you sure? The service will no longer be associated with this subscription."}
          confirmAction={() => this.deleteService()}
          confirmActionName="Remove"
          confirmClassName={"btn-warning"}
          caption="Remove API Service"
          isLoading={this.state.isDialogLoading}
        />

        {/* Add Service */}
        <Modal isOpen={this.state.isAddServiceModalVisible} size="lg">
          {!this.state.isDialogLoading
            ?  <ModalHeader toggle={() => {
                  this.handleAddServiceDialogToggle();
                  this.resetState();
                }}>
                  Add Service
                </ModalHeader>
            : <ModalHeader>Add Service</ModalHeader>
          }
          
          {!this.state.isDialogLoading &&
          <ModalBody>
            {this.state.services.length > 0 && (
                <div className="checkbox-container">
                  {this.renderServices()}
                </div>
            )}
            {this.state.services.length === 0 && (
                <span>
                  No other API Services available for that API Product.
                </span>
            )}
            {this.state.invalidFields.newSelectedServices.invalid && (
                <span className="service-error">
                  {this.state.invalidFields.newSelectedServices.message}
                </span>
            )}
          </ModalBody>
          }

          {this.state.isDialogLoading &&
            <ModalBody className="loading-body">
              <Loading />
            </ModalBody>
          }

          <ModalFooter>
            <Button
              color="btn btn-link"
              onClick={() => {
                this.handleAddServiceDialogToggle();
                this.resetState();
              }}
              disabled={this.state.isDialogLoading}
            >
              Cancel
            </Button>
            <button
              type="button"
              className="btn btn-success submit-user-button"
              onClick={() => {
                this.editSubscriptionServices();
              }}
              disabled={this.state.isDialogLoading}
            >
              Save
            </button>
          </ModalFooter>
        </Modal>

        <div className="services-table">
          <Table className="table">
            <thead>
              <tr>
                <th className="width-90">Name</th>
                <th className="width-10">{(AuthorizationService.hasPermission(Permissions.subscription.delete) && this.props.sub.connectedProducts[0].services.length > 1 && this.props.sub.isActive && !this.props.sub.isSynchronize) ? "Remove" : ""}</th>
              </tr>
            </thead>
            <tbody>{this.populateTable()}</tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/accounts/account-product-details/account-api-product-details/components/Services.js